import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',{attrs:{"name":_vm.name}},[_c(VSwitch,{attrs:{"name":_vm.name,"type":"checkbox","placeholder":_vm.placeholder,"label":_vm.label,"value":_vm.value},on:{"change":_vm.updateValue},model:{value:(_vm.is_active),callback:function ($$v) {_vm.is_active=$$v},expression:"is_active"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }